import * as React from 'react'
import './index.scss'
import { ChangeEvent } from "react";
import Select from '@material-ui/core/Select';
import { MyMenuItem } from '../CustomUIComp/CustomFormElem';
import { accoutListType } from "../../reducers/types";
interface IProps {
  accoutList: accoutListType[],
  val: string,
  currency: string,
  onChange?: ((e: ChangeEvent<HTMLInputElement>) => void),
  onCurrencyChange?: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void
}

class AmtInput extends React.Component<IProps, {}> {
  public render() {
    return (<div className="AmtInput">
      <Select
        value={this.props.currency}
        onChange={this.props.onCurrencyChange}
        className="currency"
        disableUnderline
      >
        {(this.props.accoutList || []).map((item) => (
          <MyMenuItem key={item.currency} value={item.currency}>
            {item.currency}
          </MyMenuItem>
        ))}
      </Select>
      <input placeholder="0" value={this.props.val} onChange={this.props.onChange} />
    </div>);
  }
}

export default AmtInput